<template>
	<div class="introduce">
		<div class="intr_cont">
			<div class="crumbs">当前位置：论坛首页-论坛介绍</div>
			<div class="backdrop">
				<div class="left">
					<div class="title"><span>CCEF</span>背景<img src="../../assets/wbanner_30.png" alt=""></div>
					<div class="text">首席经济学家，是机构决策者的智囊，掌握机构最核心的信息。立足于全球
						视角，首席经济学家们着眼于中国经济增长和金融市场发展中的现实问题，
						向投资者传递最真实的研究信息。</div>
					<div class="text">中国首席经济学家论坛由一批志同道合的著名经济学家发起成立，陆续囊括了国内外一流银行、券商、投行、保险、基金、资管等金融投资机构首席经济学家。目前论坛理事成员已经超过一百位。</div>
				</div>
				<div class="right"><img src="../../assets/wbanner_31.png" alt=""></div>
			</div>
			<div class="target_bg">
				<div class="target">
					<div class="target_list">
						<div class="list">
							<div class="image"><img src="../../assets/wbanner_32.png" alt=""></div>
							<div class="title"><span>CCEF</span>简介</div>
							<div class="text">“中国首席经济学家论坛”旨在以恢弘广博
								的视野来分析全球经济金融宏观局势，同时
								以探幽入微的技能来解读市场微观态势。论
								坛一方面服务于金融机构、企业（集团）的
								经济金融策略研判与选择，另一方面服务于
								国家乃至区域的战略制定与执行，以求成为
								中国经济金融政策研究的高端咨询智囊。
							</div>
						</div>
					</div>
					<div class="target_list">
						<div class="list">
							<div class="image"><img src="../../assets/wbanner_32.png" alt=""></div>
							<div class="title"><span>CCEF</span>目标</div>
							<div class="text">打造中国经济研究顶级平台，打造中国最专业、
								高效的经济交流平台。中共中央政治局委员、中
								共中央财经工作领导小组办公室主任 刘鹤寄语：
								“由衷祝贺成立这样一个有特色的论坛。贵在恒，
								望成为有较大影响力的智库。”
							</div>
						</div>
					</div>
					<div class="target_list">
						<div class="list">
							<div class="image"><img src="../../assets/wbanner_32.png" alt=""></div>
							<div class="title"><span>CCEF</span>研究院</div>
							<div class="text">中国首席经济学家研究院立足全球，聚焦中
								国经济现实问题，秉承真实·务实的理念，汇
								聚中国知名的首席经济学家和主流学者，致
								力于为政府、各类机构提供高端咨询。
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="force_bg">
				<div class="force">
					<div class="setion_one">
						<div class="title"><span>论坛</span>影响力</div>
						<div class="text">中国首席经济学家论坛在经济领域专业性、权威性达到国内顶尖层次。论坛在国内、国际上都享有较高声誉。经济研究领域覆盖银行、证券、保险、基金、信托、</div>
						<div class="text">海外投行等；首席经济学家，均来自券商（前十五）、基金（前十）、银行保险、资管、海外投行的首席经济学家，他们是机构的最高决策智囊；合作地区，</div>
						<div class="text">与北京、上海、天津、浙江、重庆、安徽、江西、福建、贵州、四川、山西、陕西、山东、江苏、内蒙古、新疆等地政府、企业等广泛合作；超过25场场大型、</div>
						<div class="text">高端经济论坛会议成功举办；自2012年以来，已形成20多份内参上报中央；论坛会议网络直播同步参与人数200W 覆盖影响力巨大；2017年中国首席经济学家
						</div>
						<div class="text">论坛杂志首发，目前已覆盖政商学界的社会高端群体，杂志受广泛关注；研究院聚焦于宏观经济大周期与政策研究、产业大周期与新型产业研究、</div>
						<div class="text">全球大类资产配置研究，目前已为政府及各类机构提供大量咨询服务。</div>
					</div>
					<div class="setion_one">
						<div class="title"><span>论坛学术</span>影响力</div>
						<div class="text">在中国学术论坛影响力排行榜中，中国首席经济学家论坛以377万个百度结果搜索量，</div>
						<div class="text">影响力跻身全国第二。用数据说话，中国首席经济学家论坛历经时间的锤炼，做到真正的有实力、有影响力。</div>
					</div>
				</div>
			</div>
			<div class="partner">
				<div class="title"><span>合作</span>媒体</div>
				<el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
					<el-tab-pane  name="first">
						<div class="list"><img src="../../assets/mt1.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt2.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt3.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt4.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt5.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt6.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt7.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt8.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt9.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt10.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt11.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt12.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt13.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt14.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt15.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt16.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt17.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt18.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt19.jpg" alt=""></div>
						<div class="list"><img src="../../assets/mt20.jpg" alt=""></div>
                        <div class="list"><img src="../../assets/mt21.jpg" alt=""></div>
				
					</el-tab-pane>
			
				</el-tabs>
			</div>
			<div class="contact_bg">
				<div class="contact">
					<div class="left">
						<div class="text">联系我们</div>
						<div class="text_en">Contact us</div>
					</div>
					<div class="right">
						<div class="list"><img src="../../assets/wbanner_36.png" alt="">地址：中国上海市虹口区东大名路1098号806-7室</div>
						<div class="list"><img src="../../assets/wbanner_37.png" alt="">电话：8621-61110219</div>
						<div class="list"><img src="../../assets/wbanner_38.png" alt="">手机：13524695255 王先生</div>
						<div class="list"><img src="../../assets/wbanner_39.png" alt="">邮箱：CCET@chinacef.cn</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'introduce',
		data() {
			return {
				activeName: 'first'
			}
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	}
</script>
</script>

<style>
	.introduce .crumbs {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.introduce .backdrop {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 45px;
		margin-bottom: 90px;
	}

	.introduce .backdrop .left {
		width: 45%;
	}

	.introduce .backdrop .left .title {
		font-size: 35px;
		color: #333333;
		font-weight: bold;
		align-items: center;
		margin-bottom: 40px;
	}

	.introduce .backdrop .left .title span {
		color: #5082ff;
	}

	.introduce .backdrop .left .title img {
		margin-left: 15px;
		vertical-align: middle;
		margin-top: -3px;
	}

	.introduce .backdrop .left .text {
		font-size: 16px;
		color: #333333;
		margin-bottom: 30px;
		line-height: 30px;
	}

	.introduce .backdrop .right {
		width: 48%;
		margin-top: 10px;
		margin-right: 25px;
	}

	.introduce .target_bg {
		background-color: #fcfcfc;
		padding: 50px 0;
	}

	.introduce .target {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.introduce .target .target_list {
		width: 32%;
		background: linear-gradient(to bottom, #ffffff, #fbfbfb);
		transition: 0.5s;
	}

	.introduce .target .target_list:hover {
		box-shadow: 0px 0px 15px #ebebeb;
		transition: 0.5s;
	}

	.introduce .target .target_list .list {
		padding: 70px 40px 50px;
	}

	.introduce .target .target_list .list .image {
		margin-bottom: 7px;
		text-align: center;
	}

	.introduce .target .target_list .list .title {
		color: #333;
		font-size: 24px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 10px;
	}

	.introduce .target .target_list .list .title span {
		color: #5082ff;
	}

	.introduce .target .target_list .list .text {
		color: #333;
		font-size: 15px;
		line-height: 30px;
	}

	.introduce .force_bg {
		background-color: #fafafa;
		padding-top: 80px;
	}

	.introduce .force {
		width: 1200px;
		margin: 0 auto;
	}

	.introduce .force .setion_one {
		padding-bottom: 80px;
	}

	.introduce .force .title {
		color: #333333;
		font-size: 30px;
		text-align: center;
		margin-bottom: 40px;
		font-weight: bold;
	}

	.introduce .force .title span {
		color: #5082ff;
	}

	.introduce .force .text {
		text-align: center;
		color: #333333;
		font-size: 16px;
		line-height: 30px;
	}

	.introduce .partner {
		width: 1200px;
		margin: 0 auto;
		padding: 80px 0;
	}

	.introduce .partner .title {
		color: #333333;
		font-size: 30px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 30px;
	}

	.introduce .partner .title span {
		color: #5082ff;
	}

	.introduce .partner .el-tabs__nav-wrap::after {
		background: rgba(0, 0, 0, 0)
	}

	.introduce .partner .el-tabs__nav-scroll {
		overflow: hidden;
		width: 350px;
		margin: 0 auto;
	}
	.el-tabs__item {
	    padding: 0px 37px;
	}
	.introduce .partner .el-tabs__item.is-active {
		color: #5082ff;
	}

	.introduce .partner .el-tabs__active-bar {
		background-color: #5082ff;
	}

	.introduce .partner .el-tab-pane {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-left: 15px;
	}

	.introduce .partner .list {
		width: 16%;
		border: 1px solid #eeeeee;
	}

	.introduce .partner .list img {
		width: 100%;
		height: 100%;
	}

	.introduce .contact_bg{
		background: #fafafa;
		padding: 23px 0;
	}
	.introduce .contact{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}
	.introduce .contact .left{
		width: 50%;
		background: url("../../assets/wbanner_35.png") no-repeat center center;
		background-size: cover;
		height: 230px;
	}
	.introduce .contact .left .text{
		font-size: 30px;
		color: #003333;
		padding: 75px 0 5px 50px;
	}
	.introduce .contact .left .text_en{
		font-size: 24px;
		color: #003333;
		margin-left: 50px;
	}
	.introduce .contact .right{
		width: 44%;
	}
	.introduce .contact .right .list {
		font-size: 16px;
		color: #333;
		margin: 40px 0;
	}
	.introduce .contact .right .list img{
		margin-right: 10px;
		vertical-align: middle;
		margin-top: -3px;
	}
	@media screen and (max-width: 1400px){
		.introduce .crumbs {
		    width: 900px;
		    margin-top: 20px;
		    font-size: 16px;
		}
		.introduce .backdrop {
		    width: 900px;
		    margin-top: 45px;
		    margin-bottom: 45px;
			align-items: center;
		}
		.introduce .backdrop .right img{
			width: 100%;
			height: auto;
		}
		.introduce .target {
		    width: 900px;
		}
		.introduce .target .target_list .list {
		    padding: 30px;
		}
		.introduce .force_bg {
		    background-color: #fafafa;
		    padding-top: 50px;
		}
		.introduce .force {
		    width: 900px;
		}
		.introduce .force .title {
		    font-size: 30px;
		    margin-bottom: 20px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 50px;
		}
		.introduce .partner {
		    width: 900px;
		    padding: 50px 0;
		}
		.introduce .contact {
		    width: 900px;
		    margin: 0 auto;
		}
	}
	@media screen and (max-width: 1000px){
		.introduce .crumbs {
		    width: 750px;
		    margin-top: 10px;
		    font-size: 16px;
		}
		.introduce .backdrop {
		    width: 750px;
		    margin-top: 20px;
		    margin-bottom: 20px;
		}
		.introduce .backdrop .left .title {
		    font-size: 24px;
		    color: #333333;
		    font-weight: bold;
		    align-items: center;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left .text {
		    font-size: 14px;
		    color: #333333;
		    margin-bottom: 0px;
		    line-height: 30px;
		}
		.introduce .target {
		    width: 750px;
		}
		.introduce .target_bg {
		    background-color: #fcfcfc;
		    padding: 20px 0;
		}
		.introduce .target .target_list .list {
		    padding: 20px;
		}
		.introduce .target .target_list .list .text {
		    color: #333;
		    font-size: 14px;
		    line-height: 30px;
		}
		.introduce .force_bg {
		    padding-top: 20px;
		}
		.introduce .force .title {
		    font-size: 24px;
		    margin-bottom: 15px;
		}
		.introduce .force .text {
		    font-size: 14px;
		    line-height: 26px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 20px;
		}
		.introduce .force {
		    width: 750px;
		}
		.introduce .partner {
		    width: 750px;
		    padding: 20px 0;
		}
		.introduce .partner .title {
		    font-size: 24px;
		    margin-bottom: 10px;
		}
		.introduce .contact {
		    width: 750px;
		}
		.introduce .contact .right .list {
		    font-size: 16px;
		    color: #333;
		    margin: 20px 0;
		}
		.introduce .contact .left .text {
		    font-size: 24px;
		    color: #003333;
		    padding: 75px 0 5px 50px;
		}
	}
	@media screen and (max-width: 768px){
		.introduce{
			margin-top: 80px;
		}
		.introduce .crumbs {
		    width: 98%;
		    margin-top: 0px;
		    font-size: 14px;
		}
		.introduce .backdrop {
		    width: 98%;
		    margin-top: 10px;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left .title {
		    font-size: 18px;
		    color: #333333;
		    font-weight: bold;
		    align-items: center;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left {
		    width: 100%;
		}
		.introduce .backdrop .right{
			 width: 100%;
			 margin: 0;
		}
		.introduce .target_bg {
		    background-color: #fcfcfc;
		    padding: 10px 0;
		}
		.introduce .target .target_list {
		    width: 100%;
		}
		.introduce .target .target_list .list .title {
		    font-size: 18px;
		}
		.introduce .target .target_list .list .image {
		    margin-bottom: 7px;
		    zoom: 0.7;
		}
		.introduce .target .target_list .list {
		    padding: 10px;
		}
		.introduce .force_bg {
		    padding-top: 10px;
		}
		.introduce .force .title {
		    font-size: 18px;
		    margin-bottom: 10px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 10px;
		}
		.introduce .force {
		     width: 98%;
		}
		.introduce .partner .title {
		    font-size: 18px;
		    margin-bottom: 10px;
		}
		.introduce .partner .list {
		    width: 32.5%;
		    border: 1px solid #eeeeee;
		}
		.introduce .partner {
		      width: 98%;
		    padding: 10px 0;
		}
		.introduce .target {
		    width: 98%;
		}
		.introduce .contact {
		    width: 98%;
			display: block;
		}
		.introduce .contact .left {
		    width: 100%;
		    background: rgba(0, 0, 0, 0);
		    background-size: cover;
		    height: auto;
		}
		.introduce .contact .right{
			width: 100%;
		}
		.introduce .contact .left .text {
		    font-size: 18px;
		    color: #003333;
		    padding: 10px 0;
		}
		.introduce .contact .left .text_en {
		    font-size: 14px;
		    color: #003333;
		    margin-left: 0px;
		}
		.introduce .contact .right .list {
		    font-size: 14px;
		    color: #333;
		    margin: 10px 0;
		}
		.introduce .contact_bg {
		    background: #fafafa;
		    padding: 10px 0;
		}
		.introduce .partner .el-tab-pane {
		    width: 100%;
		    display: flex;
		    flex-wrap: wrap;
		    margin-left: 0px;
		}
	}
</style>
